import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const containerRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip focusing on initial page load
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Focus the main content container after route change
    if (containerRef.current) {
      containerRef.current.focus({ preventScroll: false });
    }
  }, [location.pathname]);

  return (
    <div
      key={location.pathname}
      ref={containerRef}
      tabIndex={-1}
      className="animate-page-in outline-none"
    >
      {children}
    </div>
  );
};

export default PageTransition;
